<div [formGroup]="form" *ngIf="form">
  <ngx-intl-tel-input
    #telInput
    [cssClass]="submitAttempted && form.get(controlName).errors ? 'form-control is-invalid' : 'form-control'"
    [phoneValidation]="form.get(controlName).value?.countryCode === 'GB' ? false : true"
    [preferredCountries]="phoneNumberPreferedCountries"
    [selectFirstCountry]="true"
    [searchCountryFlag]="true"
    [enableAutoCountrySelect]="true"
    [customPlaceholder]="'GENERAL.phone' | translate"
    customPlaceholder=" "
    searchCountryPlaceholder="{{ 'SHARED.createBookingModal.chooseCountry' | translate }}"
    [formControlName]="controlName"
  ></ngx-intl-tel-input>
  <!-- [phoneValidation] hack for bug https://github.com/webcat12345/ngx-intl-tel-input/issues/260 -->
  <div class="invalid-feedback" *ngIf="submitAttempted && !form.get(controlName).valid && !form.get(controlName).disabled">
    {{ 'DASHBOARD.newClientForm.invalidNumber' | translate }}
  </div>
</div>
